import { render, staticRenderFns } from "./NewActivityBlock.vue.html?vue&type=template&id=14802596&scoped=true&"
import script from "./NewActivityBlock.component.js?vue&type=script&lang=vueJs&"
export * from "./NewActivityBlock.component.js?vue&type=script&lang=vueJs&"
import style0 from "./NewActivityBlock.scoped.scss?vue&type=style&index=0&id=14802596&prod&lang=vueScss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14802596",
  null
  
)

export default component.exports